import type { FC } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Alert, IconButton, Snackbar } from '@mui/material';
import AlertTitle from '@mui/material/AlertTitle';

import { SNACKBAR_STORE } from 'state/snackbar/snackbarStore';

/** MUI Snackbar component connected with SNACKBAR_STORE. */
export const ToastMessage: FC = () => {
  const isVisible = SNACKBAR_STORE((state) => state.isVisible);
  const message = SNACKBAR_STORE((state) => state.message);
  const title = SNACKBAR_STORE((state) => state.title);
  const severity = SNACKBAR_STORE((state) => state.severity);
  const autoHide = SNACKBAR_STORE((state) => state.autoHide);
  const hideSnackbar = SNACKBAR_STORE((state) => state.hideSnackbar);
  const clearSnackbar = SNACKBAR_STORE((state) => state.clearSnackbar);

  const action = (
    <IconButton size='small' aria-label='close' onClick={hideSnackbar} data-testid='toast-message-close-button'>
      <CloseIcon fontSize='small' />
    </IconButton>
  );

  return (
    <Snackbar
      open={isVisible}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={autoHide ? 1500 : null}
      sx={{ maxWidth: '30%', mt: 4 }}
      onClose={hideSnackbar}
      slotProps={{ transition: { onExited: clearSnackbar } }}
    >
      <Alert severity={severity} action={action} data-testid='toast-message'>
        {!!title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  );
};
